module.exports = __webpack_public_path__ + "img/yabanci-saglik-sigortasi.687f8c8e.png";